import { DestroyBase } from "../ng-destroy-base";

/**
 * Standardized area host base class.
 */
export abstract class AreaHostBase extends DestroyBase {
  //Nothing for now
}
